import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import NavBar from "./navbar";
import Footer from "./footer";

const PageShell  = ({children}) => {
    const location = useLocation()
    const [aosInit, setAosInit] = useState(false)

    useEffect(() => {
        if(!aosInit){
            AOS.init();
            setAosInit(true)
        }
    }, [location])

    return (
        <>
            <NavBar dark={true} />
            {children}
            <Footer />


        </>
    )
}

export default PageShell